<template>
  <div>
    <v-dialog title="Create a meeting push" :visible.sync="dialogVisible" width="1000px" @open="onOpen"
      @closed="onClosed">
      <el-row type="flex" justify="center">
        <div style="padding-left: 20px;">
          <h3 class="details-title">Step 1 Create Online Meeting</h3>
          <MeetingStepOne ref="meetingStepOne" @success="onSuccess" />
        </div>
        <div>
          <h3 class="details-title" style="margin-left: 30px;">Step 2 Create a push</h3>
          <el-form class="padding-lr" ref="form" :model="form" :rules="editMeetingFormRules" label-position="top">
            <el-form-item label="Greetings" prop="greeting">
              <el-input class="greet-input" v-model="form.greeting" maxlength="20"
                placeholder="Please input greetings" />
            </el-form-item>
            <el-form-item ref="pushToMSL" label="Setting" prop="pushToMSL" style="margin-bottom: 5px!important;">
              <div>
                <el-checkbox v-model="form.pushToMSL" :disabled="disablePushToMSL">Push to Me</el-checkbox>
                <el-button v-if="disablePushToMSL" class="bind-wechat-link" type="text" @click="bindWeChat()">
                  Bind WeChat?
                </el-button>
              </div>
              <div class="push-to-msl-msg" slot="error">{{ pushToMSLMsg }}</div>
            </el-form-item>

            <el-form-item ref="isWeComSend"  prop="isWeComSend" style="margin-bottom: 5px!important;">
              <div class="checkbox-wrapper">
                <el-checkbox v-model="form.isWeComSend" >WeCom Send</el-checkbox>
                <el-checkbox v-if="form.isWeComSend" v-model="form.contactsOnly" @change="onContactsOnlyChange" >Contacts Only</el-checkbox>
              </div>
            </el-form-item>

            <el-form-item label="Tag">
              <HcpTagSelect v-model="selectedTagIds" />
            </el-form-item>
            <el-form-item prop="seIds" :label="formItemLabel">
              <el-radio-group v-model="seType" @input="changeSeType" v-if="isSupervisor || isMSL">
                <el-radio label="All">All</el-radio>
                <el-radio label="SE">SE</el-radio>
                <el-radio label="CE">CE</el-radio>
              </el-radio-group>
              <SEMultipleSelect v-model="form.seIds" :showTips="true" :placeholder="selectPlaceholder"
                :options="seListByType" :showTag="false" type='push' @select-change="onSESelectChange" />
              <div class="selected-hcp-count">Selected: <strong>{{ form.seIds.length }}</strong></div>
            </el-form-item>
            <el-form-item label="Select Meeting" prop="meetingId">
              <el-select @change="onMeetingSelectChange" v-model="form.meetingId" placeholder="Please select meeting"
                popper-class="meeting-select">
                <el-option v-for="(item, index) in meetingTitleList" :label="item.Title" :value="item.MeetingId"
                  :key="index">
                  <span style="float: left">{{ item.Title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.range
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="Request Content" prop="requestId" v-if="isVMSL">
              <el-select filterable v-model="form.requestId" placeholder="Please select request content">
                <el-option v-for="(item, index) in requestContentList" :label="item.Name" :value="item.Id"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item prop="meetingRequestType" class="request-type">
              <el-radio-group v-model="form.meetingRequestType" @change="onRequestTypeChange">
                <div v-for="type in pushTypes" :key="type.key">
                  <el-radio :label="type.key" :key="type.key" style="line-height: 32px;">{{ type.value }}</el-radio>
                  <template v-if="form.meetingRequestType === type.key && type.key === 0 ">
                    <el-input v-model="form.requestContent" placeholder="Please input reason" />
                  </template>
                  <template v-if="form.meetingRequestType === type.key && type.key === 1 ">
                    <el-row type="flex" align="bottom" :gutter="20">
                      <el-col class="interaction-date-time">
                        <el-form-item prop="interactionDateTime" label="Interaction date/time">
                          <div class="datetime">
                            <el-date-picker v-model="iDate" type="date" :format="dateFormat" :value-format="dateFormat"
                              placeholder="Date" :editable="false" />
                            <el-select class="times-select" v-model="iTime" clearable allow-create filterable
                              placeholder="Time" @blur="onTimeBulr($event, 'iTime')" ref="iTime">
                              <i slot="prefix" class="el-input__icon el-icon-time"></i>
                              <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                            </el-select>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col class="interaction-type">
                        <el-form-item prop="interactionTypeId" label="Interaction type">
                          <el-select v-model="form.interactionTypeId" placeholder="Interaction type">
                            <el-option v-for="t in interTypes" :label="t.value" :value="t.key" :key="t.key" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item  label="Request Content">
                      <el-input v-model="form.requestContent" type="textarea" rows="3" :maxlength="200" />
                    </el-form-item>
                  </template>
                  <template v-if="form.meetingRequestType === type.key && type.key === 6 ">
                    <el-input v-model="form.requestContent" placeholder="Please input reason" />
                    <CheckboxGroup v-model="form.initActivities" class="activity_options">
                      <Checkbox v-for="activity in activityOptions" :key="activity.optionId" :label="activity.optionId">
                        {{ activity.optionValue }}
                      </Checkbox>
                    </CheckboxGroup>
                  </template>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Content" class="editor" prop="paperContent">
              <TinymceEditor v-show="visible" ref="vTinymce" :height="300" v-model="form.paperContent"
                @input="paperContentValidator" />
            </el-form-item>
          </el-form>
          <div class="footer" style="margin-top: 0;">
            <el-button type="primary" @click="onPreview" :loading="previewing">
              {{ previewLabel }}
            </el-button>
            <el-button type="primary" @click="onSubmit(1)" :disabled="actionDisabled">
              Submit push
            </el-button>
            <el-button @click="onSubmit(0)" :disabled="actionDisabled">
              Save Draft
            </el-button>
          </div>
        </div>
      </el-row>
    </v-dialog>
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="previewUrl" />
    
    <!-- 自定义HCP确认对话框 -->
    <el-dialog
      title="请确认推送的HCP"
      :visible.sync="customConfirmVisible"
      width="500px"
      :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
      class="custom-confirm-dialog"
    >
      <div class="confirm-dialog-content">
        <div class="confirm-section" v-if="confirmedContactsNames.length > 0">
          <div class="confirm-title">已添加MSL企业微信联系人：{{ confirmedContactsNames }}</div>
          <div class="confirm-hint">(可推送至医生微信)</div>
        </div>
        <div class="confirm-divider" v-if="unconfirmedContactsNames.length > 0 && confirmedContactsNames.length > 0"></div>
        <div class="confirm-section" v-if="unconfirmedContactsNames.length > 0">
          <div class="confirm-title">未添加MSL企业微信联系人： {{ unconfirmedContactsNames }}</div>
          <div class="confirm-hint">(不可推送至医生微信)</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customConfirmCancel">Cancel</el-button>
        <el-button type="primary" @click="customConfirmSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TinymceEditor from '../../components/tinymce-editor'
import QRCodeDialog from './qrcode-dialog'
import { trimValidate } from '../../utils/validator'
import MeetingStepOne from './meeting-step-one.vue';
import { RoleCode } from "@/utils/role-constant";
import SEMultipleSelect from "../../components/se-multiple-select";
import HcpTagSelect from "../../components/hcp-tag-select.vue";
import { hcpMatchesTagFilter } from "@/utils/hcp-tag-catalog";
import { CheckboxGroup, Checkbox } from 'element-ui';
import { getTimes } from "../../utils/datetime";

export default {
  name: 'create-meeting-content-dialog',
  components: { TinymceEditor, QRCodeDialog, MeetingStepOne, SEMultipleSelect, HcpTagSelect, CheckboxGroup, Checkbox },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      default: 'push',
    },
  },
  data() {
    const validatePushToMSL = (rule, value, callback) => {
      if (
        this.isSelectSEUncertified &&
        !this.pushToMSL &&
        !value
      ) {
        return callback(new Error());
      }
      callback();
    };
    return {
      isSelectSEUncertified: false,
      seType: 'All',
      selectedTagIds: [],
      dialogVisible: this.visible,
      dateFormat: "yyyy-MM-dd",
      timeFormat: "HH:mm",
      // 用于保存原始的seList数据，以便在contactsOnly勾选/取消时使用
      originalSeList: null,
      // 自定义确认对话框相关
      customConfirmVisible: false,
      // 模拟的HCP联系人数据
      confirmedContacts: [],
      unconfirmedContacts: [],
      
      form: {
        isWeComSend:false,
        contactsOnly: false,
        pushToMSL: false,
        status: '', // 0 drafft  1 submit
        greeting: '',
        seIds: [],
        shortTitle: '',
        meetingId: '',
        // requestId: '',
        paperContent: '',
        requestContent: '',
        meetingRequestType: null,
        interactionTypeId: null,
        interactionDateTime: null,
        initActivities: [],
      },
      editRow: {},
      seList: [],
      meetingTitleList: [],
      editMeetingFormRules: {
        greeting: [
          {
            required: true,
            validator: trimValidate('Please input greetings'),
            trigger: 'blur',
          },
        ],
        interactionDateTime: [
          {
            required: true,
            message: "Please select interaction date and time",
            tigger: "change",
          },
        ],
        interactionTypeId: [
          {
            required: true,
            message: "Please select interaction type",
            tigger: "change",
          },
        ],
        pushToMSL: {
          type: "boolean",
          required: false,
          trigger: "change",
          validator: validatePushToMSL,
        },
        seIds: {
          type: "array",
          required: true,
          message: "Please select HCP",
          tigger: "change",
        },
        meetingId: [
          {
            required: true,
            message: 'Please select meeting',
            trigger: 'change',
          },
        ],
        paperContent: [
          { required: true, message: 'Please input content', trigger: 'blur' },
        ],
      },
      actionDisabled: false,
      vTinymce: null,
      previewing: false,
      qrcodeDialogVisible: false,
      previewUrl: '',
      // requestContentList: [],
      iDate: "", // interaction date
      iTime: "", // interaction time
      interTypes: [],
      pushTypes: [],
      activityOptions: [],
    }
  },
  computed: {
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
    isMSL() {
      return this.$store.state.role === RoleCode.ML;
    },
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL;
    },
    // 格式化已确认的联系人名称（用逗号分隔）
    confirmedContactsNames() {
      return this.confirmedContacts.join('，');
    },
    // 格式化未确认的联系人名称（用逗号分隔）
    unconfirmedContactsNames() {
      return this.unconfirmedContacts.join('，');
    },
    seListByType() {
      let list = this.seList
      if (this.seType !== 'All') {
        list = list.filter(item => item.types ? item.types.includes(this.seType) : false)
      }
      if (this.selectedTagIds.length) {
        list = list.filter(item => hcpMatchesTagFilter(item.Tags, this.selectedTagIds))
      }
      return list
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    disablePushToMSL() {
      return this.userInfo.bindStatus !== 2;
    },
    pushToMSLMsg() {
      return this.disablePushToMSL
        ? `Please bind WeChat first then check 'Push to Me' option`
        : this.form.pushToMSL
          ? ""
          : `Please check 'Push to Me' option`;
    },
    token() {
      return this.$store.state.token
    },
    previewLabel() {
      return this.previewing ? 'Previewing' : 'Preview'
    },
    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.VMSL
        ? "vCE"
        : "HCP";
    },
    formItemLabel() {
      return `Select ${this.nameLabel}`;
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    times() {
      return getTimes("00:00", "23:30", "00:30", "00:00", "23:30");
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      this.$emit('update:visible', value)
    },
    selectedTagIds() {
      const validIds = this.seListByType.map(item => item.SEID)
      this.form.seIds = this.form.seIds.filter(id => validIds.includes(id))
    },
    iDate(value) {
      this.form.interactionDateTime =
        value && this.iTime ? `${value} ${this.iTime}` : "";
    },
    iTime(value) {
      this.form.interactionDateTime =
        value && this.iDate ? `${this.iDate} ${value}` : "";
    },
  },
  created() {
    this.editMeetingFormRules.seIds.message = this.selectPlaceholder;
  },
  methods: {
    onSESelectChange({ isUncertified }) {
      this.isSelectSEUncertified = isUncertified;
      this.$set(
        this.editMeetingFormRules.pushToMSL,
        "required",
        this.isSelectSEUncertified
      );
      if (this.isSelectSEUncertified) {
        this.$refs.form.validateField("pushToMSL");
      } else {
        this.$refs.pushToMSL.clearValidate();
      }
    },
    bindWeChat() {
      this.bus.$emit("bindWeChat");
    },
    changeSeType() {
      this.form.seIds = []
    },
    onClosed() {
      this.seType = 'All'
      this.actionDisabled = false
      this.form.shortTitle = ''
      this.editMeetingFormRules.interactionDateTime[0].required = false;
      this.editMeetingFormRules.interactionTypeId[0].required = false;
      // this.editMeetingFormRules.requestContent[0].required = false;
      this.form.requestContent = '';
      this.form.initActivities = []
      this.iDate = "";
      this.iTime = "";
      this.isSelectSEUncertified = false;
      this.form.isWeComSend = false
      this.form.contactsOnly = false
      this.$set(this.editMeetingFormRules.pushToMSL, "required", false);
      this.$refs.form.resetFields()
      this.$refs.meetingStepOne.onClosed()
    },
    onOpen() {
      this.getSEList()
      // this.requestContent()
      this.getMeetingTitleList()
      this.form.pushToMSL = this.$store.state.userInfo.bindStatus === 2;
      this.$nextTick(() => {
        this.$refs.meetingStepOne.initForm();
      });
      this.$axios
        .all([this.axios.get("/combinePush/param")])
        .then((res) => {
          this.handleParamsResp(res[0]);
        });
      if (this.isMSL || this.isSupervisor) {
        this.editMeetingFormRules.requestContent = [
          {
            required: true,
            validator: trimValidate('Please input request content'),
            trigger: 'blur',
          },
        ]
      }
    },
    onPreview() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.previewing = true
          this.axios
            .post('/content/preview', {
              ...this.form,
              greeting: this.form.greeting.trim(),
              // requestId: this.form.requestId,
              requestContent: this.form.requestContent,
              fileName: this.fileName,
              uploadName: this.uploadName,
            })
            .then(({ code, data }) => {
              if (code == 200) {
                this.previewUrl = data.url
                this.qrcodeDialogVisible = true
              } else {
                this.$message.error('Get preview qrcode failed')
              }
              this.previewing = false
            })
            .catch(() => {
              this.previewing = false
            })
        } else {
          return false
        }
      })
    },
    paperContentValidator() {
      const vTinymce = this.$refs.vTinymce
      if (vTinymce) {
        const editor = vTinymce.getEditor()
        if (editor) {
          const text = editor.getContent({ format: 'text' }).trim()
          const html = editor.getContent({ format: 'html' })
          if (
            html.indexOf('video') === -1 &&
            html.indexOf('img') === -1 &&
            html.indexOf('table') === -1
          ) {
            if (text.length > 0) {
              this.$refs.form.clearValidate('paperContent')
            }
            if (text.length === 0 && this.visible) {
              this.$set(this.form, 'paperContent', '')
              this.$refs.form.validateField('paperContent')
            }
          } else {
            this.$refs.form.clearValidate('paperContent')
          }
        }
      }
    },
    onSuccess(meetingId) {
      console.log('onSuccess')
      this.form.meetingId = meetingId
      this.getMeetingTitleList(meetingId)
    },
    async validateForm(formRef) {
      return new Promise((resolve) => {
        formRef.validate(valid => {
          valid && resolve();
        });
      });
    },
    onSubmit(status) {
      this.paperContentValidator()
      if (status == 0) {
        this.goToSubmit(status);
        return;
      }
      
      // 根据contactsOnly状态显示不同的确认对话框
      if (this.form.isWeComSend && !this.form.contactsOnly) {
        if(this.form.seIds.length>0){
          // 显示自定义确认对话框
           this.confirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && se.IsWeComEnabled).map(se => se.Name);
        this.unconfirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && !se.IsWeComEnabled).map(se => se.Name);    
        
          this.customConfirmVisible = true;
        }else{
          this.$message.error('Select HCP ')
        }
       
      } else {
        // 显示原来的确认对话框
        this.$confirm('请确认推送给HCP。', '', {
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.goToSubmit(status);
        }).catch(() => {
          return false;
        });
      }
    },
    // 自定义确认对话框确认按钮处理
    customConfirmSubmit() {
      this.customConfirmVisible = false;
      this.goToSubmit(1); // 1表示提交状态
    },
    // 自定义确认对话框取消按钮处理
    customConfirmCancel() {
      this.customConfirmVisible = false;
      return false;
    },
    goToSubmit(status) {
       let weComTypeList = this.form.seIds.map(seId => {
        let se = this.seList.find(se => se.SEID === seId);
        return {
          SEID: seId,
          IsWeComEnabled: se.IsWeComEnabled,
          Name: se.Name,
          ExternalUserId: se.ExternalUserId,
        }
      })
      this.$refs.form.validate((valid) => {
        // console.log(this.isSelectSEUncertified)
        // if (!this.isSelectSEUncertified) {
        //   return false;
        // }
        if (valid) {
          if (this.form.meetingRequestType === 6) {
          let noneReason = this.form.requestContent == '' || this.form.requestContent == null
          let noneActivity = this.form.initActivities.length == 0
          if (noneReason && noneActivity) {
            this.$message.error(
              "Please make sure you have input reason or check the checkbox for initiated activities"
            );
            return;
          }
        }  
          this.actionDisabled = true
          this.form.status = status
          this.axios
            .post('/push/meetingPush', {
              ...this.form,
              greeting: this.form.greeting.trim(),
              weComTypeList: weComTypeList,
              // requestId: this.form.requestId,
              // requestContent: this.form.requestId,
            })
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$emit('success')
                this.$message.success(
                  `${status === 1 ? 'Submit' : 'Save draft'} successfully`
                )
                this.dialogVisible = false
              } else if (code === 201) {
                this.dialogVisible = false
                this.$message.error(msg)
              } else {
                this.$message.error(msg)
                this.actionDisabled = false
              }
            })
            .catch(() => {
              this.actionDisabled = false
            })
        } else {
          return false
        }
      })
    },
    getSEList() {
      this.axios.get('/combinePush/seList').then(({ code, data, msg }) => {
        if (code === 200) {
          this.seList = data.filter(item=>item.Certified ==1)
          console.log(data)
        } else {
          this.$message.error(msg)
        }
      })
    },
    // requestContent() {
    //   this.axios.get('/quickPush/meetingRequestType').then(({ code, data, msg }) => {
    //     if (code === 200) {
    //       this.requestContentList = data
    //     } else {
    //       this.$message.error(msg)
    //     }
    //   })
    // },
    getMeetingTitleList(meetingId) {
      this.axios.get('content/meetingList').then(({ code, data, msg }) => {
        if (code === 200) {
          this.meetingTitleList = Array.from(data, (item) => {
            const format = 'YYYY-MM-DD HH:mm:ss'
            let range = `${this.moment(item.StartTime).format(
              format
            )} ~ ${this.moment(item.EndTime).format(format)}`
            item.labelRange = `${item.Title} (${range})`
            item.range = range
            return item
          })
          if (meetingId) {
            this.onMeetingSelectChange(meetingId)
          }
        } else {
          this.$message.error(msg)
        }
      })
    },
    onMeetingSelectChange(value) {
      console.log('meetingId', value)
      let meeting = this.meetingTitleList.find((i) => i.MeetingId == value)
      console.log('meeting', meeting)
      if (meeting) {
        const date = this.moment(meeting.StartTime).format('MM/DD/YYYY')
        const time = this.moment(meeting.StartTime).format('HH:mm:ss')
        this.form.paperContent = `<p>会议时间：${date} ${time} </p><p><a title="加入会议" href="${meeting.MeetingLink}" target="_blank" rel="noopener">加入会议</a></p>`
        this.form.shortTitle = meeting.Title
        this.$refs.form.clearValidate('paperContent')
      }
    },
    handleParamsResp({ code, data }) {
      if (code === 200) {
        this.pushTypes = data.pushType;
        this.activityOptions = data.initActivitiesParams;
        this.interTypes = data.interType;
        this.form.meetingRequestType = data.pushType.length > 0 ? data.pushType[0].key : "";
        this.form.interactionTypeId =
          data.interType.length > 0 ? data.interType[0].key : "";
      }
    },
    setTimeInputListener(ref) {
      this.$nextTick(() => {
        // const timeDom = this.$refs[ref];
        let refsData = this.$refs[ref];
        const timeDom = Array.isArray(refsData) ? refsData[0] : refsData;
        if (timeDom) {
          const input = timeDom.$refs.reference;
          input.$on("input", (value) => {
            value = value.length > 5 ? value.substring(0, 5) : value;
            value = value.replace(/[^0-9:\uff1a]/g, "").replace(/\uff1a/g, ":");
            timeDom.$set(timeDom, "selectedLabel", value);
          });
        }
      });
    },
    onRequestTypeChange(value) {
      // editMeetingFormRules
      this.editMeetingFormRules.interactionDateTime[0].required = value === 1;
      this.editMeetingFormRules.interactionTypeId[0].required = value === 1;
      // this.editMeetingFormRules.requestContent[0].required = false;
      this.form.requestContent = "";
      this.form.initActivities = [];
      if (value === 0 || value === 6) {
        this.iDate = "";
        this.iTime = "";
        this.form.interactionTypeId = null;
      }
      if (value === 1) {
        this.setTimeInputListener("iTime");
      }
    },
    onTimeBulr(e, ref) {
      let timeDom = this.$refs[ref];
      if (timeDom) {
        const reg = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
        if (timeDom.selectedLabel) {
          if (reg.test(timeDom.selectedLabel)) {
            this.$set(this, ref, timeDom.selectedLabel);
          } else {
            timeDom.deleteSelected(e);
          }
        }
      }
    },
    
    // Contacts Only复选框变化处理
    onContactsOnlyChange(checked) {
      if (checked) {
        // 过滤seList中weComEnable为true的HCP，并更新到原始seList
        // 先保存原始seList到一个临时变量，以便取消勾选时恢复
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        
        // 过滤seList，只保留weComEnable为true的项
        const filteredSeList = this.originalSeList.filter(se => se && se.IsWeComEnabled);
        this.seList = filteredSeList;
        
        // 获取过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(se => se.SEID);
        
        // 如果有选中的HCP，先检查是否有不支持的HCP，再过滤
        if (this.form.seIds.length > 0) {
          // 保存当前选中的HCP ID，用于检查
          const currentSeIds = [...this.form.seIds];
          
          // 检查选中的HCP中是否有weComEnable为false或不在过滤列表中的
          const hasUnsupportedContacts = currentSeIds.some(seId => {
            const se = this.originalSeList.find(s => s.SEID === seId);
            return se && !se.IsWeComEnabled || !validSeIds.includes(seId);
          });
          
          // 情况3：存在weComEnable为false或不在过滤列表中的HCP，需要弹窗确认
          if (hasUnsupportedContacts) {
            this.$confirm('已选择的HCP中有部分HCP没有添加企业微信，勾选”Contacts Only"后，没有添加企业微信的HCP将被过滤，请确认是否继续？', '提示', {
              confirmButtonText: '确定',
            cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 用户同意，过滤掉不支持的HCP
              this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
            }).catch(() => {
              // 用户拒绝，不勾选contactsOnly，并恢复原始seList
              this.form.contactsOnly = false;
              if (this.originalSeList) {
                this.seList = JSON.parse(JSON.stringify(this.originalSeList));
                this.form.seIds = currentSeIds
                this.originalSeList = null;
              }
              return; // 提前返回，避免后续代码执行
            });
          } else {
            // 没有不支持的HCP，直接过滤form.seIds
            this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
          }
        } else {
          // 没有选中的HCP，直接过滤form.seIds
          this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
        }
      } else {
        // 取消勾选时，恢复原始seList
        if (this.originalSeList) {
          this.seList = JSON.parse(JSON.stringify(this.originalSeList));
          this.originalSeList = null;
        }
        // 恢复form.seIds，确保与原始seList匹配
        const validSeIds = this.seList.map(se => se.SEID);
        this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
      }
    },
    
    // 处理联系人过滤
    handleContactsOnlyFilter() {
      if (this.form.contactsOnly) {
        // 保存原始的seList数据，只保存一次
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        
        // 过滤seList，只保留IsWeComEnabled为true的HCP
        const filteredSeList = this.seList.filter(item => item.IsWeComEnabled);
        this.seList = filteredSeList;
        
        // 重新赋值form.seIds，只保留过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(item => item.SEID);
        this.form.seIds = this.form.seIds.filter(id => validSeIds.includes(id));
      } else {
        // 取消勾选，恢复原始的seList数据
        if (this.originalSeList) {
          this.seList = JSON.parse(JSON.stringify(this.originalSeList));
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0;
    display: flex;
    max-height: 80vh;
  }

  .el-scrollbar.dialog {
    min-width: auto;
  }
}

.el-form {
  padding: 5px 30px;
}

.el-form-item {
  margin-bottom: 10px !important;

  &.editor {
    margin-bottom: 0 !important;
  }

  .el-select,
  .el-input,
  .el-textarea {
    width: 100%;
  }
}

.footer {
  // text-align: center;
  margin-left: 160px;
  margin-top: 25px;
}

.details-title {
  font-size: 14px;
  color: #535353;
  margin-left: 10px;
}

.activity_options {
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
}

.el-row {
  .el-col {

    &.interaction-date-time,
    &.interaction-type {
      width: auto !important;
    }

    &.interaction-type {
      .el-form-item {
        min-width: 150px;
      }
    }
  }

  .times-select {
    width: 110px;
  }

  .datetime {
    display: flex;
    align-items: flex-end;

    .el-date-editor {
      &:first-child {
        width: 125px !important;
      }

      &:last-child {
        width: 110px !important;
      }

      .el-input__inner {
        padding-right: 10px !important;
      }

      &:first-child {
        margin-right: 5px;
      }
    }
  }
}

::v-deep.el-form .el-form-item.request-type .el-radio .el-radio__label {
  white-space: break-spaces;
  word-break: break-word;
  vertical-align: top;
  display: inline-block;
}

::v-deep {
  .el-form-item__label {
    padding: 0 !important;
  }
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

::v-deep {
  .custom-confirm-dialog{
    .el-dialog__body{
      width: 100%;
      display: block;
      padding: 10px 30px;
          color: #000000;
    }
  }
}
.confirm-divider{
      width: 100%;
    height: 1px;
    background: #dddddd;
    margin: 20px 0;
}
</style>
